import * as React from "react";
import { memo } from "react";
const SvgHangTightBackground = (props) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", width: 450, height: 84, viewBox: "0 0 450 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M450 84L84.0691 83.9997C37.639 83.9997 0 46.3918 0 0H84.0691L450 0.000280379V84Z", fill: "#1E3F67" }));
const Memo = memo(SvgHangTightBackground);
export default Memo;
